import type { CreateFunnelModalProps } from "../AppModalTypes";

import * as React from "react";

import { useModal } from "@editor/hooks/useModal";

import { useCreateFunnel } from "@/features/funnel/hooks/useCreateFunnel";
import Button from "@replo/design-system/components/button/Button";
import { Modal } from "@replo/design-system/components/modal/Modal";

import Input from "../common/designSystem/Input";

export const CreateFunnelModal: React.FC<CreateFunnelModalProps> = ({
  projectId,
  funnelTemplateId,
}) => {
  const [name, setName] = React.useState<string>("");
  const { closeModal } = useModal();
  const { handleCreateFunnel, isLoading } = useCreateFunnel();

  const handleCreate = () => {
    void handleCreateFunnel({
      projectId: projectId ?? "",
      funnelTemplateId,
      name,
    });
    void closeModal({ type: "createFunnelModal" });
  };

  return (
    <Modal
      title={
        funnelTemplateId ? "Create Funnel From Template" : "Create New Funnel"
      }
      isOpen={true}
      onOpenChange={(open) => {
        if (!open) {
          closeModal({ type: "createFunnelModal" });
        }
      }}
      size="base"
      footer={
        <Button
          variant="primary"
          size="base"
          onClick={handleCreate}
          isLoading={isLoading}
          disabled={isLoading}
        >
          Create
        </Button>
      }
    >
      <div className="flex w-full flex-col gap-5">
        <div className="flex flex-col gap-2">
          <div className="text-default text-base font-medium">Funnel Name</div>
          <Input
            size="base"
            value={name}
            autoFocus
            onChange={(e) => setName(e.target.value)}
          />
        </div>
      </div>
    </Modal>
  );
};
